// ProtectedRoute.js
import { isAuthenticated } from 'common/utilities';
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ element: Component }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return <Component />;
};

export default ProtectedRoute;
